import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import './Detail.css';
import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faExternalLinkAlt, faBars, faTrophy } from '@fortawesome/free-solid-svg-icons';
import whatsappIcon from '../../images/wpp.png';
import logo from '../../images/logo.png';
import noRafflesImage from '../../images/no-raffles.png';
import crownImage from '../../images/Crown.png';
import medalImage from '../../images/Medal.png';
import { useNavigate } from "react-router-dom";
import baseURL from '../url';
import DetailLoading from "../DetailLoading/DetailLoading";
import PurchaseForm from "../PurchaseForm/PurchaseForm";
import SideMenu from '../SideMenu/SideMenu';
import Footer from '../Footer/Footer';
import GlobalLoader from '../Admin/GlobalLoader/GlobalLoader';
import useApiWithLoader from '../../hooks/useApiWithLoader';
export default function Detail() {
    const navigate = useNavigate();
    const { idRifa } = useParams();
    const [rifa, setRifa] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImage, setModalImage] = useState("");
    const [rifas, setRifas] = useState([]);
    const [contactos, setContactos] = useState([]);
    const [ganadores, setGanadores] = useState([]);
    const [ganador, setGanador] = useState([]);
    const [numeros, setNumeros] = useState([]);
    const [numerosDisponibles, setNumerosDisponibles] = useState(0);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [hasEnoughNumbers, setHasEnoughNumbers] = useState(true);
    const [topCompradores, setTopCompradores] = useState([]);
    const { multipleApiCalls } = useApiWithLoader();

    useEffect(() => {
        loadAllData();
    }, []);

    const loadAllData = async () => {
        const fetchFunctions = [
            // Cargar contacto
            () => fetch(`${baseURL}/contactoGet.php`, { method: 'GET' })
                .then(response => response.json())
                .then(data => setContactos(data.contacto.reverse()[0] || []))
                .catch(error => {}),
            
            // Cargar rifas
            () => fetch(`${baseURL}/rifaGet.php`, { method: 'GET' })
                .then(response => response.json())
                .then(data => {
                    setRifas(data.rifas || []);
                    // setLoading(false);
                })
                .catch(error => {}),
            
            // Cargar ganadores
            () => fetch(`${baseURL}/ganadorGet.php`, { method: 'GET' })
                .then(response => response.json())
                .then(data => setGanadores(data.ganadores || []))
                .catch(error => {}),
            
            // Cargar números específicos de la rifa (optimizado)
            () => fetch(`${baseURL}/numeroGetByRifa.php?idRifa=${idRifa}`, { method: 'GET' })
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        setNumeros(data.numeros || []);
                        setNumerosDisponibles(data.disponibles || 0);
                        setHasEnoughNumbers(data.hasEnoughNumbers || false);
                    } else {
                        console.error('Error al cargar números:', data.message);
                        setHasEnoughNumbers(false);
                    }
                })
                .catch(error => {
                    console.error('Error en la petición:', error);
                    setHasEnoughNumbers(false);
                }),
            
            // Cargar top compradores
            () => {
                if (!idRifa) return Promise.resolve();
                return fetch(`${baseURL}/topCompradoresGet.php?idRifa=${idRifa}`, { method: 'GET' })
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            setTopCompradores(data.topCompradores || []);
                        } else {
                            setTopCompradores([]);
                        }
                    })
                    .catch(error => setTopCompradores([]));
            }
        ];

        await multipleApiCalls(fetchFunctions);
    };

    useEffect(() => {
        const rif = rifas.find((e) => e.idRifa === parseInt(idRifa));
        setRifa(rif);

        // Filtrar los ganadores para obtener solo aquellos que pertenecen a la rifa actual
        const ganados = ganadores.filter((e) => e.idRifa === parseInt(idRifa));
        setGanador(ganados);
    }, [idRifa, rifas, ganadores]);

    if (!rifa) {
        return <DetailLoading />;
    }

    return (
        <div className="detail" >
            
            {/* Header */}
            <header className="main-header">
                <div className="header-left">
                    <img 
                        src={logo} 
                        alt="Logo" 
                        className="header-logo" 
                        onClick={() => navigate('/')}
                        style={{ cursor: 'pointer' }}
                    />
                </div>
                <div className="header-center">
                </div>
                <div className="header-right">
                    <button className="menu-button" onClick={() => setIsMenuOpen(true)}>
                        <FontAwesomeIcon icon={faBars} />
                    </button>
                </div>
            </header>

            <div className="detail-contain">
                {/* Left Column - Raffle Card */}
                <div className="detail-raffle-section">
                    {rifa && (
                        <div className="raffle-card-container">
                            <div className="raffle-card">
                                <div className="raffle-image">
                                    <img 
                                        src={rifa.imagen1} 
                                        alt={rifa.nombre}
                                        onError={(e) => {
                                            e.target.src = noRafflesImage; // Imagen de respaldo
                                        }}
                                        onLoad={() => {
                                        }}
                                    />
                                </div>
                                
                                <div className="prize-section">
                                    <h2>{rifa.nombre}</h2>
                                    {rifa.descripcion && (
                                        <p className="rifa-descripcion">{rifa.descripcion}</p>
                                    )}
                                    <p>Fecha Límite: {rifa.finalizacion}.</p>
                                </div>

                                <div className="ticket-cost">
                                    <span className="cost-label">Costo Ticket</span>
                                    <span className="cost-value">{rifa.moneda} {rifa.precio}</span>
                                </div>

                                <div className="progress-section">
                                    <span className="progress-label">Tickets Reservados</span>
                                    <div className="progress-bar">
                                        <div 
                                            className="progress-fill" 
                                            style={{ width: `${rifa.porcentaje_vendido || 0}%` }}
                                        ></div>
                                    </div>
                                    <span className="progress-percentage">
                                        {rifa.porcentaje_vendido || 0}%
                                    </span>
                                </div>

                                {/* Top Compradores */}
                                <div className="top-compradores-section">
                                    <h3 className="top-compradores-title">
                                        <FontAwesomeIcon icon={faTrophy} />
                                        Top Compradores
                                    </h3>
                                    {topCompradores.length > 0 ? (
                                        <div className="compradores-list">
                                            {topCompradores.map((comprador, index) => (
                                                <div key={index} className="comprador-item">
                                                    <div className="comprador-rank">
                                                        {index === 0 && <img src={crownImage} alt="Crown" className="crown-icon" />}
                                                        {index > 0 && <img src={medalImage} alt="Medal" className="medal-icon" />}
                                                    </div>
                                                    <div className="comprador-name">
                                                        {comprador.nombre}
                                                    </div>
                                                    <div className="comprador-tickets">
                                                        {comprador.total_tickets} Tickets
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="no-compradores">
                                            <p>No hay compradores registrados aún</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {/* Right Column - Form Section */}
                <div className="detail-form-section">
                    <PurchaseForm 
                        hasEnoughNumbers={hasEnoughNumbers}
                        numerosDisponibles={numerosDisponibles}
                        idRifa={idRifa}
                        rifa={rifa}
                    />
                </div>
            </div>

            <Footer />

            {/* Modal de Bootstrap para mostrar imágenes */}
            <Modal 
                show={isModalOpen} 
                onHide={() => setIsModalOpen(false)}
                size="lg"
                centered
                backdrop="static"
                keyboard={true}
            >
                <Modal.Header closeButton className="bg-dark text-white">
                    <Modal.Title>
                        <FontAwesomeIcon icon={faExternalLinkAlt} className="me-2" />
                        {rifa?.titulo || 'Imagen de la Rifa'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                    <div className="text-center">
                        <img 
                            src={modalImage} 
                            alt={rifa?.titulo || 'Imagen de la rifa'} 
                            className="img-fluid"
                            style={{ maxHeight: '70vh', objectFit: 'contain' }}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer className="bg-light">
                    <Button 
                        variant="secondary" 
                        onClick={() => setIsModalOpen(false)}
                        className="d-flex align-items-center"
                    >
                        <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Menú lateral */}
            <SideMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />

            {/* Global Loader */}
            <GlobalLoader />

        </div>
    );
}
